import React, { useState, useEffect } from "react";

const BottomSheetCalendar = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  // Add useEffect to load existing date from localStorage
  useEffect(() => {
    const loadExistingDate = () => {
      try {
        const userQ = localStorage.getItem("userQ");
        if (userQ) {
          const searchDetails = JSON.parse(userQ);
          if (searchDetails && searchDetails.date) {
            const existingDate = new Date(searchDetails.date);
            setSelectedDate(existingDate);
            setCurrentDate(existingDate);
          }
        }
      } catch (error) {
        console.error("Error loading date from localStorage:", error);
        // Fallback to current date if there's an error
        const fallbackDate = new Date();
        setSelectedDate(fallbackDate);
        setCurrentDate(fallbackDate);
      }
    };

    loadExistingDate();
  }, []); // Empty dependency array means this runs once on mount

  const getDaysInMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
  };

  const handlePrevMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1),
    );
  };

  const handleNextMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1),
    );
  };

  const handleDateSelect = (day) => {
    const newDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      day,
    );
    setSelectedDate(newDate);
    props.onChangeDate(newDate);
    props.validate();
  };

  const isToday = (day) => {
    const today = new Date();
    return (
      today.getDate() === day &&
      today.getMonth() === currentDate.getMonth() &&
      today.getFullYear() === currentDate.getFullYear()
    );
  };

  const isSelected = (day) => {
    return (
      selectedDate.getDate() === day &&
      selectedDate.getMonth() === currentDate.getMonth() &&
      selectedDate.getFullYear() === currentDate.getFullYear()
    );
  };

  const renderCalendarDays = () => {
    const daysInMonth = getDaysInMonth(currentDate);
    const firstDay = getFirstDayOfMonth(currentDate);
    const days = [];

    // Empty cells for days before the first day of the month
    for (let i = 0; i < firstDay; i++) {
      days.push(<div key={`empty-${i}`} className="h-12"></div>);
    }

    // Days of the month
    for (let day = 1; day <= daysInMonth; day++) {
      days.push(
        <button
          key={day}
          onClick={() => handleDateSelect(day)}
          className={`h-12 w-12 rounded-full flex items-center justify-center text-sm font-medium transition-colors ${
            isSelected(day)
              ? "bg-blue-500 text-white"
              : isToday(day)
                ? "bg-blue-100 text-blue-700"
                : "hover:bg-gray-100 text-gray-700"
          }`}
        >
          {day}
        </button>,
      );
    }

    return days;
  };

  // Close on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const formatSelectedDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <div className="bg-gray-50 p-4 z-50 ">
      <div className=" mx-auto flex align-middle justify-center  ">
        <button
          onClick={() => setIsOpen(true)}
          className="   flex align-middle items-center  justify-center transform bg-black hover:bg-gray-700 text-white text-xs rounded-full  transition-all duration-300 z-50"
        > 
<div className="ml-4">
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" stroke="currentColor" stroke-width="2" fill="none"/>
  <line x1="16" y1="2" x2="16" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  <line x1="8" y1="2" x2="8" y2="6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2"/>
  <circle cx="8" cy="14" r="1" fill="currentColor"/>
  <circle cx="12" cy="14" r="1" fill="currentColor"/>
  <circle cx="16" cy="14" r="1" fill="currentColor"/>
</svg>

</div>
          <span className="lg:block hidden  m-2 text-white mr-4">
            {formatSelectedDate(selectedDate)}
          </span>

          <span className="lg:hidden block m-2 text-white mr-4">
            {formatSelectedDate(selectedDate)}
          </span>
        </button>

        <button
          onClick={() => props.openCart()}
          className="ml-2  p-2 flex align-middle items-center  justify-center transform bg-white hover:bg-gray-100 text-black text-xs rounded-full  transition-all duration-300 z-50"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <circle cx="9" cy="20" r="1.5" fill="currentColor" />
            <circle cx="17" cy="20" r="1.5" fill="currentColor" />
            <path
              d="M3 4h2l2.4 9.6a2 2 0 0 0 2 1.4h8.2a2 2 0 0 0 1.9-1.4l1.5-5H6"
              stroke="currentColor"
              stroke-width="2"
              fill="black"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      {/* Bottom Sheet Overlay */}
      {isOpen && (
        <div className="fixed  inset-0 z-50 flex items-end justify-center">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black bg-opacity-50 transition-opacity"
            onClick={() => setIsOpen(false)}
          ></div>

          {/* Bottom Sheet */}
          <div className="mb-20 relative w-full max-w-md bg-white rounded-t-2xl rounded-b-2xl shadow-2xl transform transition-transform duration-300 ease-out">
            {/* Handle */}
            <div className="flex justify-center pt-3 pb-2">
              <div className="w-10 h-1 bg-gray-300 rounded-full"></div>
            </div>

            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
              <h2 className="text-lg font-semibold text-gray-900">
                Select delivery date
              </h2>
              <button
                onClick={() => setIsOpen(false)}
                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path
                    d="M6 6 L18 18 M6 18 L18 6"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    fill="none"
                  />
                </svg>
              </button>
            </div>

            {/* Calendar Content */}
            <div className="px-6 pb-6">
              {/* Month Navigation */}
              <div className="flex items-center justify-between py-4">
                <button
                  onClick={handlePrevMonth}
                  className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                  >
                    <path
                      d="M15 6 L9 12 L15 18"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      fill="none"
                    />
                  </svg>

                  {/* <ChevronLeft size={20} className="text-gray-600" />*/}
                </button>
                <h3 className="text-lg font-semibold text-gray-900">
                  {months[currentDate.getMonth()]} {currentDate.getFullYear()}
                </h3>
                <button
                  onClick={handleNextMonth}
                  className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                  >
                    <path
                      d="M9 6 L15 12 L9 18"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      fill="none"
                    />
                  </svg>
                </button>
              </div>

              {/* Week Days */}
              <div className="grid grid-cols-7 gap-1 mb-2">
                {weekDays.map((day) => (
                  <div
                    key={day}
                    className="h-10 flex items-center justify-center"
                  >
                    <span className="text-xs font-medium text-gray-500">
                      {day}
                    </span>
                  </div>
                ))}
              </div>

              {/* Calendar Grid */}
              <div className="grid grid-cols-7 gap-1">
                {renderCalendarDays()}
              </div>

              {/* Action Buttons */}
              <div className="flex gap-3 mt-6">
                <button
                  onClick={() => setIsOpen(false)}
                  className="flex-1 py-3 px-4 border border-gray-300 text-gray-700 font-medium rounded-full hover:bg-gray-50 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={() => setIsOpen(false)}
                  className="flex-1 py-3 px-4 bg-black text-white font-medium rounded-full hover:bg-blue-600 transition-colors"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BottomSheetCalendar;
